import React from "react";

const Footer = () => {
    return (
      <footer>
        <div className='footer-content'>
          <div className='about'>
            <h1>
              Hay<span>Style</span>
            </h1>
            <p>
              Website hayStyle menyediakan berbagai macam kebutuhan fashion Anda
            </p>
          </div>
          <div className='content'>
            <h2>Produk</h2>
            <ul>
              <li>Kaos</li>
              <li>Celana</li>
              <li>Jaket</li>
            </ul>
          </div>
          <div className='content'>
            <h2>MarketPlace</h2>
            <ul>
              <li>Tokopedia</li>
              <li>Shopee</li>
              <li>Lazada</li>
            </ul>
          </div>
          <div className='content'>
            <h2>Kontak Kami</h2>
            <ul>
              <li>haystyle@gmail.com</li>
              <li>0812-1480-4531 (dudi)</li>
              <li>Bandung, Jawa Barat</li>
            </ul>
          </div>
        </div>

        <p className='copyright'>
          Copyright 2022@
          <span>
            <span className='style'>Hay</span>Style
          </span>
        </p>
      </footer>
    );
}

export default Footer